export default __webpack_public_path__ + "static/media/WM.b408c6b0.webp";